import { snakeCaseify, removeNullishFields } from '../../../utils'
import {
  ApiMarketplaceUser,
  MarketplaceUser,
  LoadMarketplaceUsersParams,
} from '@types'

interface LoadMarketplaceUsersCoodinator {
  RestService: {
    get: (
      url: string,
      params: LoadMarketplaceUsersParams,
    ) => Promise<ApiMarketplaceUser[]>
  }
  pResponseMarketplaceUsers: (json: ApiMarketplaceUser[]) => MarketplaceUser[]
}
export const LoadMarketplaceUsers =
  ({
    RestService,
    pResponseMarketplaceUsers,
  }: LoadMarketplaceUsersCoodinator) =>
  async (params: LoadMarketplaceUsersParams) => {
    const users = await RestService.get(
      '/api/admin/marketplace_users',
      snakeCaseify(removeNullishFields(params)),
    )

    return pResponseMarketplaceUsers(users)
  }

interface SendWelcomeEmailCoordinator {
  RestService: {
    post: (
      url: string,
      params: {
        marketplaceUserId: string
      },
    ) => Promise<void>
  }
  UIService: {
    FlashMessage: {
      displaySuccessMessage: (message: string) => void
    }
  }
  HandleError: any
}
export const SendWelcomeEmail =
  ({ RestService, UIService, HandleError }: SendWelcomeEmailCoordinator) =>
  async (params: { marketplaceUserId: string }) => {
    try {
      await RestService.post(
        '/api/admin/marketplace_users/send_welcome_email',
        snakeCaseify(params),
      )
      UIService.FlashMessage.displaySuccessMessage(
        'Welcome email sent successfully',
      )
    } catch (error) {
      HandleError({ error })
    }
  }
